import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../../context/global/state";
import PdsFooterStyles from "./styles/pdsFooterStyles";
import Phone from "./assets/phone.svg";
import Contact from "./assets/mail.svg";
import NoDemoLink from "../../controllers/shared/tooltip/noDemoLink";
import LinkNoPath from "../../controllers/shared/Links/linkNoPath";

const Footer: React.FC = () => {
	const [menuRef, setMenuRef] = useState<any>(null);
	const { state, dispatch } = useGlobalContext();
	const ref = React.createRef<HTMLDivElement>();

	// Save ref to global state
	useEffect(() => {
		if (ref.current) {
			if (!state.pdsFooter) {
				setMenuRef(ref.current);
				dispatch({ type: "pdsFooter", payload: ref.current });
			}
		}
	}, [ref, state.pdsFooter, menuRef, dispatch]);

	const footerProps = {
		ref,
		className: `pds-footer hideSection`, // PDS is hidden by default
	};

	return (
		<>
			<PdsFooterStyles />
			<footer {...footerProps}>
				<section className="pds-footer-row">
					<div>
						<ul className="pds-footer-nav-inline">
							<li>
								<img
									src={Phone}
									alt="phone"
									className="util-margin-right-10"
								/>
								<NoDemoLink>
									<LinkNoPath className="pds-link-unstyled pds-link-icon-left pds-link-icon-utility">
										800-986-3343
									</LinkNoPath>
								</NoDemoLink>
							</li>
							<li>
								<img
									src={Contact}
									alt="contact"
									className="util-margin-right-10"
								/>
								<NoDemoLink>
									<LinkNoPath className="pds-link-unstyled pds-link-icon-left pds-link-icon-utility">
										Contact us
									</LinkNoPath>
								</NoDemoLink>
							</li>
						</ul>
						<ul className="pds-footer-nav-inline">
							<li>
								<NoDemoLink>
									<LinkNoPath>Terms of use</LinkNoPath>
								</NoDemoLink>
							</li>
							<li>
								<NoDemoLink>
									<LinkNoPath>Disclosures</LinkNoPath>
								</NoDemoLink>
							</li>
							<li>
								<NoDemoLink>
									<LinkNoPath>Privacy</LinkNoPath>
								</NoDemoLink>
							</li>
							<li>
								<NoDemoLink>
									<LinkNoPath>Security</LinkNoPath>
								</NoDemoLink>
							</li>
							<li>
								<NoDemoLink>
									<LinkNoPath>Report fraud</LinkNoPath>
								</NoDemoLink>
							</li>
							<li>
								<NoDemoLink>
									<LinkNoPath>Site map</LinkNoPath>
								</NoDemoLink>
							</li>
						</ul>
					</div>
					<div className="pds-footer-legal">
						<p>
							2021, Principal Financial Services, Inc.
							<br /> Securities offered through Principal
							Securities, Inc.,{" "}
							<NoDemoLink>
								<LinkNoPath>member SIPC</LinkNoPath>
							</NoDemoLink>
						</p>
					</div>
				</section>
			</footer>
		</>
	);
};

export default Footer;
